import React from "react";
import { MdArrowBackIosNew } from "react-icons/md";
import { useTranslation } from "react-i18next";
import EAButton from "../shared/Buttons/EAButton";
import SingleConcert from "./singleConcert";
import EASkeletonLoader from "../shared/EASkeletonLoader";
import useTourDetails from "./hooks/useTourDetails";
import EAAlert from "../shared/EAAlert";

const TourDetails: React.FC = () => {
  const { t } = useTranslation();
  const {
    isExpanded,
    setIsExpanded,
    showButton,
    articleRef,
    handleBack,
    exerciseName,
    exerciseDescription,
    exercises,
    loading,
  } = useTourDetails();

  if (loading) {
    return <EASkeletonLoader height="400px" />;
  }

  if (exercises.length <= 0) {
    return <EAAlert message={t("Nie znaleziono wydarzeń.")} type="warning" />;
  }

  return (
    <>
      <div className="tour-details__header">
        <EAButton title={t("wroc")} onClick={handleBack} startIcon={<MdArrowBackIosNew />} variant="text" noMargins />
        <h1>
          {t("kup_bilet")}: <b>{exerciseName}</b>
        </h1>
        <div className="tour-details__description-container">
          <article
            ref={articleRef}
            className={
              isExpanded ? "tour-details__description tour-details__description--expanded" : "tour-details__description"
            }
            dangerouslySetInnerHTML={{ __html: exerciseDescription }}
          ></article>
          {showButton && (
            <EAButton
              title={isExpanded ? t("pokaz_mniej") : t("pokaz_wiecej")}
              onClick={() => setIsExpanded(!isExpanded)}
              variant="text"
              noMargins={true}
            />
          )}
        </div>
      </div>

      <div>
        {exercises && (
          <div className="tour-details__events">
            {exercises.map((item, index) => (
              <div className={"event-block"} key={index}>
                <SingleConcert item={item} />
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default TourDetails;
